<template>
  <p
    v-if="isVisible"
    :class="$style.root"
  >
    <PremiumFeatureFlag
      feature="systemInsights"
    >
      <template v-slot:else>
        <Icon
          :class="$style.icon"
          icon="info"
        />
      </template>
    </PremiumFeatureFlag>

    <ButtonLink
      :class="$style.link"
      :text="linkText"
      @click="handleClick"
    /> {{ additionalText }}
  </p>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts, StoreModelMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import ButtonLink from 'client/components/Buttons/ButtonLink.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import PremiumFeatureFlag from 'components/Badges/PremiumFeatureFlag.vue';
import RouterService from 'client/util/RouterService';
import SystemInsightsComponentMixin from 'client/systems/systemInsights/mixins/SystemInsightsComponentMixin';
import SystemInsightsConstants from 'client/util/Constants/SystemInsightsConstants';

const systemModel = StoreModelMap[ItemTypeConsts.system];
const { enabled, deferred } = SystemInsightsConstants.systemState;

export default {
  name: 'EnableSystemInsightsCTA',

  components: {
    ButtonLink,
    Icon,
    PremiumFeatureFlag,
  },

  mixins: [SystemInsightsComponentMixin],

  props: {
    additionalText: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => {},
    },
    linkText: {
      type: String,
      default: 'Enable System Insights',
    },
    onClick: {
      type: Function,
      default: null,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    handleClick() {
      return this.onClick ? this.onClick : this.handleEnableDeviceSI;
    },
    isVisible() {
      return this.isSystemInsightsSupported
        && !this.showSystemInsights
        && !this.deviceSystemInsightsEnabled;
    },
  },

  methods: {
    ...mapActions(systemModel, ['setItemField']),

    handleEnableDeviceSI() {
      if (this.hasSystemInsights) {
        ModalEventBus.open({
          component: 'DeviceEnableSystemInsightsModal',
        });

        const state = this.item.systemInsights.state === enabled ? deferred : enabled;
        const key = 'systemInsights';
        const value = { state };

        this.setItemField({ key, value });
      } else {
        this.redirectToFeatureSettings();
      }
    },

    redirectToFeatureSettings() {
      RouterService.redirect({
        path: '#/settings/features',
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },
  },

};
</script>

<style module scoped>
@value (jcInformationalBase) from '~css/brand-colors.css';

.root {
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: var(--jc-spacer-x-small);
}

.icon {
  display: flex;
}

.link {
  color: jcInformationalBase;
  cursor: pointer;
  line-height: 1.5;
}
</style>
